import * as mutations from '@store/types/mutations-types'


export const selectProduct = (product, store) => {
  store.commit(mutations.SET_PRODUCT, product)

  const firstVariant = product.variants[0]

  store.commit(mutations.SET_DRAFT, {
    productId: product.id,
    parameters: [(firstVariant === undefined ? '' : firstVariant.parameters[0])],
  })
}
